import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import AuthPanel from "./AuthPanel";

export default function AuthModal({ open, onClose }) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-panel border-line text-hi max-w-sm" data-testid="auth-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black uppercase tracking-wide flex items-center gap-2">
            <KeyRound className="w-5 h-5 text-ember" /> Sign in
          </DialogTitle>
          <DialogDescription className="text-mid text-sm">
            Open fleet command with your email and password.
          </DialogDescription>
        </DialogHeader>
        <AuthPanel
          idPrefix="modal"
          onSuccess={() => {
            onClose();
            navigate("/app");
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
